export const ENGRAVING = 'engraving_folder'
export const ELECTRONIC_SAW = 'electronic_saw_folder'
export const LABELING = 'labeling_folder'
export const SIDE_HOLE = 'side_hole_folder'
export const DOCK5F_DRILL = 'dock5F_drill_folder'
export const DOCK6F_DRILL = 'dock6F_drill_folder'
export const PTP = 'PTP_folder'
export const LABEL_IMAGE = 'label_image_folder'
export const PAIBAN1 = 'paiban1'
export const PAIBAN2 = 'paiban2'
export const AIO_FOLDER = 'aio_folder'
export const SURPLUS_FOLDER = 'surplus_folder'
export const PAIBANIMG_FOLDER = 'paibanImg_folder'
export const DOOR_WALL_AIO_FOLDER = 'door_wall_aio_folder'

export const fileNameSetObj = {
  [ENGRAVING as string]: '雕刻机',
  [ELECTRONIC_SAW as string]: '电子锯',
  [LABELING as string]: '贴标机',
  [SIDE_HOLE as string]: '侧孔机',
  [DOCK5F_DRILL as string]: '五面钻',
  [DOCK6F_DRILL as string]: '六面钻',
  [PTP as string]: 'PTP',
  [LABEL_IMAGE as string]: '贴标图片',
  [PAIBAN1 as string]: '排版图1',
  [PAIBAN2 as string]: '排版图2',
  [AIO_FOLDER as string]: '一体机',
  [SURPLUS_FOLDER as string]: '余料大板',
  [PAIBANIMG_FOLDER as string]: '排版图',
  [DOOR_WALL_AIO_FOLDER as string]: '门墙柜一体机',
}

export const folderKeyList = [
  ENGRAVING,
  ELECTRONIC_SAW,
  LABELING,
  SIDE_HOLE,
  DOCK5F_DRILL,
  DOCK6F_DRILL,
  PTP,
  LABEL_IMAGE,
  SURPLUS_FOLDER,
  DOOR_WALL_AIO_FOLDER,
]
// 操作记录对应table的类型
export const operateRecordTableType = {
  SPECIAL_MATERIAL_TABLE: 'special_material_table', // 原片管理-特别材质
  STANDARD_MATERIAL_TABLE: 'standard_material_table', // 原片管理-标准板材
  BRAND_MATERIAL_TABLE: 'brand_material_table', // 原片管理-品牌材质
  BLANK_KNIFE_TABLE: 'blank_knife_table', // 原片管理-原片下料刀
  SURPLUS_DEPOT_TABLE: 'surplus_depot_table', // 余料管理-余料清单
  SURPLUS_STORE_TABLE: 'surplus_store_table', // 余料管理-余料库
  BUJIAN_PLANK_TABLE: 'bujian_plank_table', // 补件和待排版库-板件
  HOLE_SLOT_TABLE: 'hole_slot_table', // 设备对接-开料机设置-孔槽
  KNIFE_STORE_TABLE: 'knife_store_table', // 设备对接-雕刻机-开料对接-刀库
  MENTAOJI_SAW_TABLE: 'mentaoji_saw_table', // 设备对接-雕刻机-开料对接-门套机
  KNIFE_TOOL_TABLE: 'knife_tool_table', // 设备对接-雕刻机-排钻设置-刀具
  CUTTING_PARAMS_PLANK_TABLE: 'cutting_params_plank_table', // 设置对接-雕刻机-切割参数-不同板厚
  CUSTOM_SPECIAL_HOLE_SLOT_SIDE_TABLE: 'custom_special_hole_slot_side_table', // 设置对接-雕刻机-切割参数-特殊孔槽自定义加工面
  LAYOUT_SETTINGS_TABLE: 'layout_settings_table', // 设备对接-雕刻机-贴标设置-排版图设置
  CUSTOMER_FORM_TABLE: 'customer_form_table', // 设备对接-默认生产线-电子锯-自定义表单
  SIDE_HOLE_KNIFE_STORE_TABLE: 'side_hole_knife_store_table', // 设备对接-侧孔机-刀库
  SIDE_HOLE_FRONT_KNIFE_STORE_TABLE: 'side_hole_front_knife_store_table', // 设备对接-侧孔机-正面加工-刀库
  PTP_KNIFE_STORE_TABLE: 'ptp_knife_store_table', // 设备对接-PTP-刀库
  SIDE_HOLE_OLD_KNIFE_STORE_TABLE_V1: 'side_hole_old_knife_store_table_v1', // 设备对接-侧孔机-旧版设置-刀库V1
  SIDE_HOLE_OLD_KNIFE_STORE_TABLE_V3: 'side_hole_old_knife_store_table_v3', // 设备对接-侧孔机-旧版设置-刀库V3
  SIDE_HOLE_OLD_KNIFE_STORE_TABLE_V4: 'side_hole_old_knife_store_table_v4', // 设备对接-侧孔机-旧版设置-刀库V4
  SIDE_HOLE_DRILL_SETTING_DRILL_COMBINATION_FROM_HOLE_TABLE:
    'side_hole_drill_setting_drill_combination_from_hole_table', // 设备对接-排钻设置-排钻组合下刀-从孔列表
  MODEL_AIO_TABLE: 'model_aio_table', // 设备对接-一体机-刀具
  FIVE_SIX_KNIVES_TABLE: 'five_six_knives_table',
  PLANK_NAME_PLACEMENT_TABLE: 'plank_name_placement_table', // 设备对接-五六面钻-指定板件名摆放
  EMERGENCY_SETTING: 'emergency_setting_table',
  CUSTOM_THROUGH_TWO_SIDE_TO_CUT_TABLE: 'custom_through_two_side_to_cut_table', // 设备对接-雕刻机-切割参数-不生效翻面两次打穿孔槽
  PREVENT_BREAKAGE_RULES_TABLE: 'prevent_breakage_rules_table', // 设备对接-雕刻机-切割参数-边缘槽隔条防断规则
  BIG_PLANK_LENGTH_MARKING_RANGE: 'big_plank_length_marking_range_table', // 设备对接-雕刻机-雕刻参数-大板长度标识
  BIG_PLANK_THICKNESS_MARKING_RANGE: 'big_plank_thickness_marking_range_table', // 设备对接-雕刻机-开料对接-大板厚度标识
  SINGLE_FILE_HOLE_RANGE: 'single_file_hole_range_table', // 设备对接-雕刻机-NC导出-孔生效范围
  SINGLE_FILE_SLOT_RANGE: 'single_file_slot_range_table', // 设备对接-雕刻机-NC导出-槽生效范围
  LASER_CUTTING_MACHINE_TABLE: 'laser_cutting_machine_table', // 设备对接-激光一体机-刀库
  MATERIAL_LIST_TABLE_HEADER: 'material_list_table_header', // 开料清单-自定义表头
  BRIDGE_COUNT_RULES_TABLE: 'bridge_count_rules_table', // 设备对接-雕刻机-切割参数-搭桥留点法-生成方式
}
// 前端自定义唯一id的key值
export const webId = 'webId'
